import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { mesquiteNVConfig } from "./data";

export default function MesquiteNVPage() {
  return <OregonCityPageTemplate config={mesquiteNVConfig} />;
}